import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_PREVIEW_EDIT_EXPERIMENT = defineFcm('starfish_preview_edit_experiment')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: ['corgi-front-end'],
		context: 'Start a Petition',
		description:
			'Experiment to test flow variants between the preview and edit steps within the Start a Petition flow.',
		import: false,
	});
